import ApexCharts, { ApexOptions } from 'apexcharts'
import React, { useEffect, useMemo, useRef } from 'react'
import { getCSS } from '../../../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../../../_metronic/partials'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useGetContractType, useGetJobTitle } from '../../core/_query'
import { DashboardContractType } from '../../core/_models'
import LoadingChart from '@/app/modules/apps/dashboard/components/LoadingChart'

type Props = {
  className: string
  title?: string
}

const ContractTypePieChart: React.FC<Props> = ({className, title}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const {state} = useQueryRequest()
  const {data: contractTypeData, isLoading} = useGetContractType({...state, set_is_job_therapist: true})
  
  const contractTypes = useMemo(() => {
        return contractTypeData?.response?.data
      }, [contractTypeData])

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, contractTypes))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, contractTypes])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3'>{title}</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        {isLoading && <LoadingChart />}
        {contractTypeData === null && <label className='form-label'>no result data</label>}
        {!isLoading && (
          <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '290px'}}></div>
        )}
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { ContractTypePieChart }

function getChartOptions(height: number, data: DashboardContractType[] | undefined): ApexOptions {
  let arrayOfSeries: any = []
  let arrayOfLabels: any = []
  if (data !== undefined) {
    arrayOfSeries = data?.map((obj) => (obj.total !== null ? obj.total : 0))
    arrayOfLabels = data?.map((obj) => (obj.contract_type !== null ? obj.contract_type : 'undefined'))
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
  }

  return {
    series: arrayOfSeries,
    chart: {
      // width: 380,
      type: 'pie',
    },
    labels: arrayOfLabels,
    legend: {
      position: 'top',
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      // y: {
      //   formatter: function (val) {
      //     return 'Rp. ' + numberWithCommas(val)
      //   },
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          // chart: {
          //   width: 200,
          // },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  }
}
